export interface AsyncStateMessageProps {
    readonly isLoading: boolean;
    /** What went wrong, or null; leave it out for something that can't fail (a page still loading). */
    readonly error?: string | null;
    /** Whether it loaded with nothing to show; leave it and `emptyMessage` out for something that can't be empty. */
    readonly isEmpty?: boolean;
    readonly loadingMessage: string;
    readonly emptyMessage?: string;
    readonly className?: string;
}

/**
 * Renders the loading/error/empty status line for a fetched list or record,
 * in that priority order. Renders nothing once data has actually loaded
 * (`isLoading` false, `error` null, `isEmpty` false) - the caller renders
 * its real content for that case itself, gated on the same three values.
 */
export function AsyncStateMessage({
    isLoading,
    error = null,
    isEmpty = false,
    loadingMessage,
    emptyMessage = '',
    className,
}: AsyncStateMessageProps): JSX.Element | null {
    if (isLoading) {
        return <p className={className}>{loadingMessage}</p>;
    }

    if (error !== null) {
        return <p className={className}>{error}</p>;
    }

    if (isEmpty) {
        return <p className={className}>{emptyMessage}</p>;
    }

    return null;
}
